/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:46 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 9:29 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { configureStore } from '@reduxjs/toolkit';

// Reducers
import animationReducer from './slices/animation/animation.slice';
import componentReducer from './slices/component/component.slice';
import consentReducer from './slices/consent/consent.slice';
import currentMessageReducer from './slices/currentMessage/currentMessage.slice';
import currentQuestionReducer from './slices/currentQuestion/currentQuestion.slice';
import currentResourceReducer from './slices/currentResource/currentResource.slice';
import currentResourcePromptReducer from './slices/currentResourcePrompt/currentResourcePrompt.slice';
import currentResourceLocaleReducer from './slices/currentResourceLocale/currentResourceLocale.slice';
import currentStoryReducer from './slices/currentStory/currentStory.slice';
import dimensionsReducer from './slices/dimensions/dimensions.slice';
import localeReducer from './slices/locale/locale.slice';
import metricReducer from './slices/metric/metric.slice';
import partnerReducer from './slices/partner/partner.slice';
import questionReducer from './slices/question/question.slice';
import questionTagReducer from './slices/questionTag/questionTag.slice';
import resourceReducer from './slices/resource/resource.slice';
import resourceManifestReducer from './slices/resourceManifest/resourceManifest.slice';
import resourcePromptReducer from './slices/resourcePrompt/resourcePrompt.slice';
import feedReducer from './slices/feed/feed.slice';
import groundingExerciseReducer from './slices/groundingExercise/groundingExercise.slice';
import storyTagReducer from './slices/storyTag/storyTag.slice';
import uiReducer from './slices/ui/ui.slice';
import userReducer from './slices/user/user.slice';


/**
 * Store
 */

export default (preloadedState) => configureStore({
	reducer: {
		animation: animationReducer,
		component: componentReducer,
		consent: consentReducer,
		currentMessage: currentMessageReducer,
		currentQuestion: currentQuestionReducer,
		currentResource: currentResourceReducer,
		currentResourcePrompt: currentResourcePromptReducer,
		currentResourceLocale: currentResourceLocaleReducer,
		currentStory: currentStoryReducer,
		dimensions: dimensionsReducer,
		locale: localeReducer,
		metric: metricReducer,
		partner: partnerReducer,
		question: questionReducer,
		questionTag: questionTagReducer,
		resource: resourceReducer,
		resourceManifest: resourceManifestReducer,
		resourcePrompt: resourcePromptReducer,
		feed: feedReducer,
		groundingExercise: groundingExerciseReducer,
		storyTag: storyTagReducer,
		ui: uiReducer,
		user: userReducer
	},
	preloadedState
});
